// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2IN-h","loaderOuter":"PageOverlayLoader_loaderOuter__30LXu"};